import deepMerge from 'deepmerge'

// Add addtional themes here.
export const lightTheme = 'light'
export const darkTheme = 'dark'

const lightBackground = '#fafafa'
const darkBackground = '#1e1e1e'

const baseOverride = {
  palette: {
    action: {
      active: '#000000'
    },
    text: {
      primary: '#000000',
      secondary: '#000000'
    },
    primary: {
      main: '#1975BC',
      dark: '#0064AE',
      light: '#2BA5FF'
    },
    secondary: {
      main: '#1975BC',
    },
    toast: {
      backgroundSuccess: '#EDF7ED',
      backgroundWarning: '#FFF4E5',
      backgroundError: '#FDEDED',
      backgroundInfo: '#E5F6FD',
      color: 'black',
    },
    table: {
      selectedRow: '#F3F5F7',
      clickOnRow: '#C6DCF9',
      normalRow: '#FFF'
    }
  },
  typography: {
    toast: {
      fontSizeTitle: '14px',
      fontSizeMessage: '14px'
    }
  },
  shape: {
    borderRadius: '8px'
  },
  overrides: {
    MuiTreeItem: {
      root: {
        '&$selected > $content $label': {
          backgroundColor: lightBackground,
        },
        '&$selected > $content $label:hover, &$selected:focus > $content $label': {
          backgroundColor: lightBackground,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent',
          },
        },
      }
    },
    MuiOutlinedInput: {
      root: {
        /*
        '& $notchedOutline': {
          borderColor: 'green'
        },
        '&:hover $notchedOutline': {
          borderColor: 'red'
        },
        '&$focused $notchedOutline': {
          borderColor: 'purple'
        },
        */
      },
      input: {
        padding: '15px 14px',
      }
    },
    MuiInputLabel: {
      outlined: {
        '&$shrink': {
          padding: '7px',
          paddingLeft: '3px'
        }
      },
    },
  }
}

const themeCommon = {
  palette: {
    routePageBackground: '#F3F3F3',
    routeSubPageBackground: '#FFFFFF',
    toastTitleFontSize: '14px',
    toastMessageFontSize: '14px',
    badgeBackgroundColor: 'red',
    dashboardBackgroundColor: '#f3f5f7',
    dashboardInnerBackgroundColor: '#ffffff',
    subPageHeaderBackground: '#EBEBEB',
    tableRowHoverColor: 'rgb(0, 0, 0, 0.04)',
    tableRowSelectedColor: 'rgb(0, 0, 0, 0.09)',
    textFieldUnderlineColor: 'rgb(145, 145, 145)',
    textFieldHoverUnderlineColor: 'rgb(31, 31, 31)',
    dashboardReportTitleBackground: 'rgb(245, 245, 245)',
    buttonDisabledBackgroundColor: '#DDDDDD',
    buttonDisabledColor: '#7D7D7D',
    white: '#FFFFFF',
  }
}

// Override the MUI light theme object
const lightThemeOverride = {
  palette: {
    type: lightTheme,
    background: {
      default: lightBackground
    },
  },
}

// Override the MUI dark theme object
const darkThemeOverride = {
  palette: {
    type: darkTheme,
    background: {
      paper: darkBackground,
      default: darkBackground
    },
    tableRowHoverColor: 'rgb(255, 255, 255, 0.07)',
    tableRowSelectedColor: 'rgb(255, 255, 255, 0.12)',
    textFieldUnderlineColor: 'rgb(188, 188, 188)',
    textFieldHoverUnderlineColor: 'white'
  },
}

// Add additional themes here.

// Add additional theme constants here. They index themeChoices below.
export const LIGHT_THEME = 0
export const DARK_THEME = 1

// Add additional themes below for the themes dropdown.
export const themeChoices = [
  {
    value: lightTheme,
    label: 'global.themes.lightTheme',
    themeObject: lightThemeOverride
  },
  {
    value: darkTheme,
    label: 'global.themes.darkTheme',
    themeObject: darkThemeOverride
  }
]

// Add additional untranslated themes below for storybook documentation.
export const untranslatedThemeChoices = [
  {
    value: lightTheme,
    label: 'Light Theme',
    themeObject: lightThemeOverride
  },
  {
    value: darkTheme,
    label: 'Dark Theme',
    themeObject: darkThemeOverride
  }
]

// This is used to set the app theme with MUI.
export const globalThemeOverrideObject = strTheme => {
  const entry = themeChoices.find(e => e.value === strTheme)
  if (!entry) {
    throw new Error('Invalid theme.')
  }
  return deepMerge.all([baseOverride, themeCommon, entry.themeObject])
}

export const themeType = themeObj =>
  themeObj.palette.type
